import React from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    // Link,
    // useNavigate,
    // Outlet,
} from "react-router-dom";
import App from "./App";
function Home() {
    return (
        <Router>
            {/*Implementing Routes for respective Path */}
            <Routes>
                <Route path="/" element={<App />} />
                <Route path="/:refId" element={<App />}/>
                {/* <Route path="/monument-referral/:refId" element={<App />}/> */}
            </Routes>
        </Router>
    );
}

export default Home;
